import Alert from "../Alert"


export const CashOutUnavailableAlert = ({ isOpen, onClose }) => {
    return (
        <Alert
            title="Cash out unavailable"
            description="Cash out is no longer available for this fund."
            isOpen={isOpen}
            isCancel={false}
            btnTxt="OK"
            handleAction={onClose}
            />
    )

}